import {
	CreateFailureDefinitionRequest,
	GetAllFailureDefinitionsResponse,
	GetFailureDefinitionResponse,
	GetFailureDefinitionRunResultsResponse,
	GetFailureDefinitionRunResultsRequest,
} from '@Types';
import failureDefinitionApi from '@Apis/failureDefinition.api';
import { AxiosResponse } from 'axios';

export const upsertFailureDefinition = (
	request: CreateFailureDefinitionRequest & { failure_definition_id?: string },
	tenantId: string,
) => {
	return failureDefinitionApi.post('failure-definitions', request, {
		headers: {
			'x-tenant-id': tenantId,
		},
	});
};

export const runFailureDefinition = (id: string, tenantId: string) => {
	return failureDefinitionApi.post(
		`failure-definitions/${id}/actions/run`,
		{},
		{
			headers: {
				'x-tenant-id': tenantId,
			},
		},
	);
};

export const getFailureDefinitions = (tenantId: string) => {
	return failureDefinitionApi.get<GetAllFailureDefinitionsResponse>('failure-definitions', {
		headers: {
			'x-tenant-id': tenantId,
		},
	});
};

export const getFailureDefinition = (id: string, tenantId: string) => {
	return failureDefinitionApi.get<GetFailureDefinitionResponse>(`failure-definitions/${id}`, {
		headers: {
			'x-tenant-id': tenantId,
		},
	});
};

export const copyFailureDefinition = (id: string, tenantId: string) => {
	return failureDefinitionApi.post(
		`failure-definitions/${id}/actions/copy`,
		{},
		{
			headers: {
				'x-tenant-id': tenantId,
			},
		},
	);
};

export const deleteFailureDefinition = (id: string, tenantId: string) => {
	return failureDefinitionApi.post(
		`failure-definitions/${id}/actions/delete`,
		{},
		{
			headers: {
				'x-tenant-id': tenantId,
			},
		},
	);
};

export const getFailureDefinitionRunResults = (
	request: GetFailureDefinitionRunResultsRequest,
	tenantId: string,
): Promise<AxiosResponse<GetFailureDefinitionRunResultsResponse>> => {
	return failureDefinitionApi.post(
		`/failure-definitions/${request.failureDefinitionId}/run/${request.runId}`,
		{
			failure_definition_id: request.failureDefinitionId,
			run_id: request.runId,
			order_by: request.orderBy,
			order: request.order,
			filters: request.filters,
			search_text: request.searchText,
			page: request.page,
			page_size: request.pageSize,
			filter_logistic_operator: request.filter_logistic_operator ?? 'and',
		},
		{
			headers: {
				'x-tenant-id': tenantId,
			},
		},
	);
};

export const updateFailureDefinition = (
	id: string,
	tenantId: string,
	updates: {
		name?: string;
		published?: boolean;
	},
) => {
	return failureDefinitionApi.post(`failure-definitions/${id}/actions/update`, updates, {
		headers: {
			'x-tenant-id': tenantId,
		},
	});
};
